import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import { routes } from '@/router'

import { ProductionCreate } from './production-create.component'
import { ProductionDetailContainer } from './production-detail/production-detail.container'
import { ProductionHome } from './production-home.component'

export const ProductionContainer = () => {
  return (
    <Switch>
      <Route exact path={routes.production.home} component={ProductionHome} />
      <Route exact path={routes.production.create} component={ProductionCreate} />
      <Route exact path={routes.production.detail(':selfId')} component={ProductionDetailContainer} />
      <Redirect to={routes.production.home} />
    </Switch>
  )
}
